import React, { useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return <Fragment>{children}</Fragment>;
}

export default ScrollToTop;
// import React, { useEffect, Fragment } from 'react';
// import { withRouter } from 'react-router-dom';

// function Index({ history, children }) {
//     useEffect(() => {
//         const unlisten = history.listen(() => {
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         });
//         return () => {
//             unlisten();
//         }
//     }, [history]);

//     return <Fragment>{children}</Fragment>;
// }

// export default withRouter(Index);